import { Parser } from 'json2csv';
import { FORMULAR, GET_TEXT, GET_TEXT_FROM, GET_ZKRATKA } from '@/main/store/getterTypes';
import { ZKRATKA_SUFFIX } from '@/main/mixins/localization';
import { store } from '@/main/store';

export function forceFileDownload(url: any, name: string = 'file.csv') {
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', name);
	document.body.appendChild(link);
	link.click();
}
export function parseObj2Csv(dataForexport: any) {
	const json2csvParser = new Parser();
	return json2csvParser.parse(dataForexport);
}

export function renameKeys(obj: Record<string, any>) {
	Object.keys(obj).forEach((key, index) => {
		if (index === 0) {
			delete obj[key];
		}
		const newKey = localize(key);
		// eslint-disable-next-line no-prototype-builtins
		if (obj.hasOwnProperty(key)) {
			obj[newKey] = obj[key];
			delete obj[key];
		}
	});
	return obj;
}
export function renameKeysForExportFunc(obj: Record<string, any>) {
	Object.keys(obj).forEach((key) => {
		if (obj[key] === undefined) {
			delete obj[key];
		}
		let newKey = localize(key);

		// eslint-disable-next-line no-prototype-builtins
		if (obj.hasOwnProperty(newKey)) {
			newKey = `_${newKey}`;
		}
		// eslint-disable-next-line no-prototype-builtins
		if (obj.hasOwnProperty(key)) {
			obj[newKey] = obj[key];
			delete obj[key];
		}
	});
	return obj;
}
export function localize(key: string) {
	if (key.endsWith(ZKRATKA_SUFFIX)) {
		const zkratkaKey = key.slice(0, -ZKRATKA_SUFFIX.length);
		return store.getters[GET_ZKRATKA](zkratkaKey);
	}
	return store.getters[GET_TEXT](key);
}
export function localizeFileName(key: string) {
	if (key.endsWith(ZKRATKA_SUFFIX)) {
		const zkratkaKey = key.slice(0, -ZKRATKA_SUFFIX.length);
		return store.getters[GET_ZKRATKA](zkratkaKey);
	}
	return store.getters[GET_TEXT_FROM](FORMULAR, key);
}
export function validateFiletype(file: any, maxSize: number, type: 'image-document' | 'image' | 'document' | 'any' | 'csv-type') {
	const imageTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/bmp'];
	const documentTypes = ['application/pdf', 'text/plain'];
	const csvTypes = ['application/vnd.ms-excel'];
	let isTypeValid = [...imageTypes, ...documentTypes].includes(file.raw.type);

	switch (type) {
		case 'image': isTypeValid = imageTypes.includes(file.raw.type); break;
		case 'document': isTypeValid = documentTypes.includes(file.raw.type); break;
		case 'image-document': isTypeValid = [...imageTypes, ...documentTypes].includes(file.raw.type); break;
		case 'csv-type': isTypeValid = csvTypes.includes(file.raw.type); break;
	}
	if (!isTypeValid) {
		return ({
			result: false,
			message: 'InvalidFileType',
		});
	}
	if (file.size > maxSize) {
		return ({
			result: false,
			message: 'FileSizeExceed',
		});
	}
	return ({
		result: true,
		message: 'CorrectFile',
	});
}

export function validateFiletypeForXLSX(file: any) {
	const xlsxTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
	const fileName: string = file.name || (file.raw && file.raw.name) || '';
	const isXlsxExtension = fileName.toLowerCase().endsWith('.xlsx');
	const isTypeValid = xlsxTypes.includes(file.raw.type) && isXlsxExtension;

	if (!isTypeValid) {
		return ({
			result: false,
			message: 'InvalidFileType',
		});
	}
	return ({
		result: true,
		message: 'CorrectFile',
	});
}

export function handleChange(file: Record<string, any>) {
	return [file];
}

export function handleRemove(file: File, fileList: any[]) {
	return fileList;
}
